import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import { useTranslationApp } from "../../../lib/i18next";
import {
  CALENDAR_ACTIVE_AUTOMATIONS,
  CALENDAR_AUTOMATION_ENDS,
} from "../../../i18n/keysTranslations";
import { toZonedDisplayDate } from "../../../utils/timezone";
import { INPUT_COLOR_BORDER } from "../../../utils/colors";
import { BORDER_RADIUS } from "../../../utils/constants";

const formatEndDate = ({ activeUntil, timezone }) => {
  const zoned = toZonedDisplayDate({
    date: activeUntil,
    timezone,
  });
  if (!zoned) return "";
  return zoned.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const CalendarActiveAutomationsBar = ({ automations = [] }) => {
  const { t } = useTranslationApp();
  if (automations.length === 0) return null;

  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{ mb: 1, color: "text.primary" }}
      >
        {t(CALENDAR_ACTIVE_AUTOMATIONS, { count: automations.length })}
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          overflowX: "auto",
          pb: 0.5,
        }}
      >
        {automations.map((automation) => {
          const endLabel = Number.isFinite(automation.activeUntil)
            ? formatEndDate({
                activeUntil: automation.activeUntil,
                timezone: automation.timezone,
              })
            : "";

          return (
            <Box
              key={automation.id}
              sx={{
                minWidth: 180,
                maxWidth: 240,
                flex: "0 0 auto",
                px: 1.5,
                py: 1,
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                borderRadius: BORDER_RADIUS,
                backgroundColor: "background.paper",
              }}
            >
              <Typography
                variant="body2"
                fontWeight={600}
                noWrap
                title={automation.name}
              >
                {automation.name}
              </Typography>
              {automation.folderLabel ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mt: 0.25,
                  }}
                >
                  <FolderOutlined sx={{ fontSize: 14, color: "text.secondary" }} />
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {automation.folderLabel}
                  </Typography>
                </Box>
              ) : null}
              {endLabel ? (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mt: 0.25 }}
                >
                  {t(CALENDAR_AUTOMATION_ENDS, { date: endLabel })}
                </Typography>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CalendarActiveAutomationsBar;
